<template>
  <div
    class="horizontal-product-main"
    id="carouselCont"
    :class="{ 'shimmer-border pb24': showExtraDiv }"
  >
    <section class="carousel" dir="ltr" aria-label="Gallery">
      <div class="carousel__viewport">
       <div class="card-login-carousel" data-v-52270af6="">
                <div class="c-img-wrap shimmer-container" data-v-52270af6="">
                  <div class="card-img img-product-home"></div>
                </div>
              </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      showExtraDiv: false,
    };
  },
  mounted() {
    if (this.type) {
      this.showExtraDiv = true;
    }
  },
};
</script>
